const invoiceMethods = {
  getFullMain: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'Ibill/GetFullMain',
      },
      AUTHENTICATED: {
        apiSuffixName: 'Ibill/GetFullMainAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getAllInvoices: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'Ibill/GetAllInvoices',
      },
      AUTHENTICATED: {
        apiSuffixName: 'Ibill/GetAllInvoicesAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getMainInvoices: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetMain',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getDetailsInvoices: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetDetails',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getInvoiceDataBySectionSubscriberNo: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetInvoiceDataBySectionSubscriberNo',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getHistoryPdfList: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetHistoryPdfList',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCallsMain: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetCallsMain',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCallsList: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetCallsList',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCreditData: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetCreditData',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCallsLogAuth: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetCallsLogAuth',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCallsLogAuthCheckLogin: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetCallsLogAuthCheckLogin',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getPdfLogAuth: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetPdfLogAuth',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getPdfAuthCheckLogin: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetPdfAuthCheckLogin',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getAllProducts: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'Ibill/GetAllProducts',
      },
      AUTHENTICATED: {
        apiSuffixName: 'Ibill/GetAllProductsAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkInvoicePermission: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'Ibill/CheckInvoicePermission',
      },
      AUTHENTICATED: {
        apiSuffixName: 'Ibill/CheckInvoicePermissionAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  validateOtpInvoice: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/ValidateOtp',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getMeterParameter: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetMeterParameter',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getEnergyBundleDetails: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ibill/GetEnergyBundleDetails',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
};

export default invoiceMethods;

